import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

@Entity('feild_mapping')
export class FeildMappingEntity {

    @PrimaryGeneratedColumn("increment", {
        name: "id",
    })
    id: number;

    @Column('varchar', {
        nullable: true,
        name: "customer_number",
    })
    customerNumber: string;

    @Column('varchar', {
        nullable: true,
        name: "customer_name",
    })
    customerName: string;

    @Column('varchar', {
        nullable: true,
        name: "customer_po_no",
    })
    customerPONo: string;

    @Column('varchar', {
        nullable: true,
        name: "supplier_name",
    })
    supplierName: string;

    @Column('varchar', {
        nullable: true,
        name: "currency",
    })
    currency: string;

    @Column('varchar', {
        nullable: true,
        name: "requested_date",
    })
    requestedDate: string;

    @Column('varchar', {
        nullable: true,
        name: "delivery_method",
    })
    deliveryMethod: string;

    @Column('varchar', {
        nullable: true,
        name: "payment_terms",
    })
    paymentTerms: string;

    @Column('varchar', {
        nullable: true,
        name: "ship_to",
    })
    shipTo: string;

    @Column('varchar', {
        nullable: true,
        name: "delivery_terms",
    })
    deliveryTerms: string;

    @Column('varchar', {
        nullable: true,
        name: "packaging_terms",
    })
    packagingTerms: string;

    @Column('varchar', {
        nullable: true,
        name: "supplier_reference",
    })
    supplierReference: string;

    @Column('varchar', {
        nullable: true,
        name: "SNo",
    })
    SNo: string;

    @Column('varchar', {
        nullable: true,
        name: "item_description",
    })
    itemDescription: string;

    @Column('varchar', {
        nullable: true,
        name: "description1",
    })
    description1: string;

    @Column('varchar', {
        nullable: true,
        name: "description2",
    })
    description2: string;

    @Column('varchar', {
        nullable: true,
        name: "quantity",
    })
    quantity: string;

    @Column('varchar', {
        nullable: true,
        name: "unit_measurement",
    })
    unitMeasurement: string;

    @Column('varchar', {
        nullable: true,
        name: "price",
    })
    price: string;

    @Column('varchar', {
        nullable: true,
        name: "price_unit",
    })
    priceUnit: string;

    @Column('varchar', {
        nullable: true,
        name: "line_amount",
    })
    lineAmount: string;

    @Column('varchar', {
        nullable: true,
        name: "item_number",
    })
    itemNumber: string;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: string;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: string;

    @Column('int', {
        nullable: true,
        name: 'version',
    })
    version: number;

    @Column({
        nullable: false,
        name: "is_active",
        default: 1
    })
    isActive: boolean;

}